import { print } from 'graphql';

import createOneCourseMetricDefinitionMutation from '~/shared/graphql-queries/course-metric-definitions/create-one-course-metric-definition-mutation';
import findManyCourseMetricDefinitionsQuery from '~/shared/graphql-queries/course-metric-definitions/find-many-course-metric-definitions-query';
import removeByIdCourseMetricDefinitionMutation from '~/shared/graphql-queries/course-metric-definitions/remove-by-id-course-metric-definition-mutation';
import updateByIdCourseMetricDefinitionMutation from '~/shared/graphql-queries/course-metric-definitions/update-by-id-course-metric-definition-mutation';
import type { BuilderType } from '~/types';

type FindManyCourseMetricDefinitionsResponse = Readonly<{
  data?: {
    findManyCourseMetricDefinitions?: Record<string, unknown>[];
  };
}>;

type FindManyCourseMetricDefinitionsResult = ReadonlyArray<Record<string, unknown>>;

type FindManyCourseMetricDefinitionsArgs = Readonly<{
  filter?: Record<string, unknown>;
  sort?: string;
}>;

type CreateOneCourseMetricDefinitionArgs = Readonly<{
  record?: Record<string, unknown>;
}>;

type UpdateByIdCourseMetricDefinitionArgs = Readonly<{
  _id?: string;
  record?: Record<string, unknown>;
}>;

type RemoveByIdCourseMetricDefinitionArgs = Readonly<{
  _id?: string;
}>;

const transformCourseMetricDefinitionsResponse = (
  response: FindManyCourseMetricDefinitionsResponse,
): FindManyCourseMetricDefinitionsResult => {
  return response?.data?.findManyCourseMetricDefinitions ?? [];
};

export const courseMetricDefinitionsTagTypes = ['course-metric-definitions'] as const;

export const getCourseMetricDefinitionsQuery = (builder: BuilderType) => {
  return {
    findManyCourseMetricDefinitions: builder.query<
      FindManyCourseMetricDefinitionsResult,
      FindManyCourseMetricDefinitionsArgs
    >({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findManyCourseMetricDefinitionsQuery),
          variables: {
            filter: args?.filter ?? {},
            sort: args?.sort ?? 'ORDER_ASC',
          },
        }),
      }),
      transformResponse: transformCourseMetricDefinitionsResponse,
      providesTags: ['course-metric-definitions'],
    }),

    createOneCourseMetricDefinition: builder.mutation<unknown, CreateOneCourseMetricDefinitionArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(createOneCourseMetricDefinitionMutation),
          variables: {
            record: args?.record,
          },
        }),
      }),
      invalidatesTags: ['course-metric-definitions'],
    }),

    updateByIdCourseMetricDefinition: builder.mutation<unknown, UpdateByIdCourseMetricDefinitionArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(updateByIdCourseMetricDefinitionMutation),
          variables: {
            _id: args?._id,
            record: args?.record,
          },
        }),
      }),
      invalidatesTags: ['course-metric-definitions'],
    }),

    removeByIdCourseMetricDefinition: builder.mutation<unknown, RemoveByIdCourseMetricDefinitionArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(removeByIdCourseMetricDefinitionMutation),
          variables: {
            _id: args?._id,
          },
        }),
      }),
      invalidatesTags: ['course-metric-definitions'],
    }),
  };
};
